export default "__VITE_ASSET__BA13e2CT__"